import React, { useEffect, useState } from 'react'
import Card from 'antd/lib/card'
import BSSLogo from '../components/Certificate/BSSLogo'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'

const styles = {
    card: {
        background: 'rgba(255, 255, 255, 0.74)',
        borderRadius: '0 0 10px 10px',
        padding: '0 0.32em',
    },

    helpContainer: {
        padding: '0.84em',
        backgroundColor: '#104862',
        color: 'white',
        borderRadius: '10px 10px 0 0',
    },
    formContainer: {
        position: 'absolute',
        left: '50%',
        margin: 'auto',
        top: '55%',
        transform: 'translate(-50%, -50%)',
        width: 540,
    },
    logoContainer: {
        margin: '10px auto',
        textAlign: 'center',
        width: 260,
    },
    inputContainer: {
        marginTop: '1.4em',
    },
    label: {
        display: 'block',
        marginBottom: '0.2em',
        color: '#666'
    },
    nameContainer: {
        marginTop: '0.4em',
        marginBottom: '0.6em'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '1.64em',
        fontWeight: 600
    },
    loginButton: {
        width: 140,
        borderRadius: 7
    },
    error: {
        color: 'red',
        marginBottom: '0.6em',
        textAlign: 'center'
    }
}


const SSOErrorPage = () => {

    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const handleRequest = async (e) => {
        e.preventDefault();
    };

    return (
        <>
            <div style={styles.logoContainer}>
                <svg
                    version="1.1"
                    viewBox="0 0 126.17 53.72"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <BSSLogo />
                </svg>
            </div>

            <div style={styles.formContainer}>
                <div style={styles.helpContainer}>
                    <p style={{ textAlign: 'center' }}>
                        Thank you for attempting to log in to BSS Guardian and taking steps to get better prepared! Unfortunately, we couldn't find your email address in the system. Please reach out to your company admin or email support@bssnet.com to request access. You can also use the form below to contact BSS Client service directly.
                    </p>
                    <p style={{ textAlign: 'center' }}>
                        We are here to help and look forward to getting you set up!
                    </p>
                </div>
                <Card style={styles.card}>
                    <form onSubmit={handleRequest} style={styles.container}>
                        <div style={styles.nameContainer}>
                            <label style={styles.label}>Your Name (Required):</label>
                            <Input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Name"
                                autoComplete="name"
                                disabled={isLoading}
                            />
                        </div>

                        <div style={styles.inputContainer}>
                            <label style={styles.label}>Email (required):</label>
                            <Input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email"
                                autoComplete="email"
                                disabled={isLoading}
                            />
                        </div>


                        <div style={styles.inputContainer}>
                            <label style={styles.label}>Company Name (required):</label>
                            <Input
                                value={company}
                                onChange={(e) => setCompany(e.target.value)}
                                placeholder="Company Name"
                                autoComplete="company"
                                disabled={isLoading}
                            />
                        </div>


                        {errorMessage && (
                            <div style={styles.error}>
                                {errorMessage}
                            </div>
                        )}

                        <div style={styles.buttonContainer}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                style={styles.loginButton}
                                loading={false}
                                disabled={false}
                            >
                                {false ? 'Submitting request...' : 'Submit Request'}
                            </Button>
                        </div>

                        <p style={{ marginTop: 20 }}>
                            Our client service team will contact you via email withing 24 hours
                        </p>
                    </form>
                </Card>
            </div >
        </>
    )
}

export default SSOErrorPage
